import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";

const baseStyle = defineStyle({
  fontSize: "sm",
  marginEnd: "0",
  mb: "1",
  fontWeight: "semibold",
  whiteSpace: "nowrap",
  textStyle: "label2",
});

export const FormLabel = defineStyleConfig({
  baseStyle,
});
